import {
  TOGGLE_SIDEBAR
} from '../../constants/actionTypes';

export const toggleSibarState = () => ({
  type: TOGGLE_SIDEBAR
})
